class StoreChatGroup {
  constructor (
    id = undefined,
    name,
    lastMessageContent,
    userIds,
    deviceIds,
    nrOfUnreadMessages = 0,
    hasDangerUnread = false,
    lastMessageAt = null,
    memberCount = undefined,
    description = null,
    photoId = null,
    photoUrl = null,
    attachedDeviceCount = undefined,
    createdByUserId = null
  ) {
    this.id = id
    this.name = name
    this.description = description
    this.photoId = photoId
    this.photoUrl = photoUrl
    this.lastMessageContent = lastMessageContent
    this.nrOfUnreadMessages = Number(nrOfUnreadMessages) || 0
    this.hasDangerUnread = !!hasDangerUnread
    this.lastMessageAt = lastMessageAt
    this.memberCount = memberCount
    this.attachedDeviceCount = attachedDeviceCount
    this.userIds = userIds
    this.users = []
    this.deviceIds = deviceIds
    this.devices = []
    this.createdByUserId = createdByUserId ?? null
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name,
      description: this.description ?? null,
      photoId: this.photoId ?? null,
      // lastMessageContent is read-only
      userIds: this.userIds,
      deviceIds: this.deviceIds
      // createdByUserId is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    lastMessageContent,
    userIds,
    deviceIds,
    nrOfUnreadMessages,
    hasDangerUnread,
    lastMessageAt,
    memberCount,
    description,
    photoId,
    photoUrl,
    attachedDeviceCount,
    createdByUserId
  }) {
    return new StoreChatGroup(
      id,
      name,
      lastMessageContent,
      userIds,
      deviceIds,
      nrOfUnreadMessages,
      hasDangerUnread,
      lastMessageAt,
      memberCount,
      description,
      photoId,
      photoUrl,
      attachedDeviceCount,
      createdByUserId
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      photoId: this.photoId,
      photoUrl: this.photoUrl,
      lastMessageContent: this.lastMessageContent,
      nrOfUnreadMessages: this.nrOfUnreadMessages,
      hasDangerUnread: this.hasDangerUnread,
      lastMessageAt: this.lastMessageAt,
      memberCount: this.memberCount,
      attachedDeviceCount: this.attachedDeviceCount,
      userIds: this.userIds,
      deviceIds: this.deviceIds,
      createdByUserId: this.createdByUserId
    }
  }

  static FromJSON ({
    id,
    name,
    lastMessageContent,
    userIds,
    deviceIds,
    nrOfUnreadMessages,
    hasDangerUnread,
    lastMessageAt,
    memberCount,
    description,
    photoId,
    photoUrl,
    attachedDeviceCount,
    createdByUserId
  }) {
    return new StoreChatGroup(
      id,
      name,
      lastMessageContent,
      userIds,
      deviceIds,
      nrOfUnreadMessages,
      hasDangerUnread,
      lastMessageAt,
      memberCount,
      description,
      photoId,
      photoUrl,
      attachedDeviceCount,
      createdByUserId
    )
  }
}

export default StoreChatGroup
